import { useContext, useState } from "react";
import { I18nContext } from "../../I18nProvider";
import { Container, Grid, Button, Input, Alert } from "@mui/material";
import { themePalette } from "../../config/theme.config";
import Papa, { ParseResult } from 'papaparse';

export const InvestigadorAdmin: React.FC<{}> = () => {
	const context = useContext(I18nContext);
	const [jsonData, setJsonData] = useState<any[]>([]);
	const [alertMessage, setAlertMessage] = useState<string | null>(null);
	const [alertSeverity, setAlertSeverity] = useState<'error' | 'success'>('success');

	const expectedHeaders = [
		"Author",
		"Scopus Author ID",
		"Tags",
		"Level 1",
		"Level 2",
		"Level 3",
		"Level 4",
		"Level 5",
		"Level 6",
		"Level 7",
		"Level 8",
		"Level 9",
		"Level 10",
		"Ongoing Correction Request"
	];

	if (context === null) {
		throw new Error(
			"The I18n context is not initialized. Make sure you have the provider set up correctly."
		);
	}

	const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		if (!file) return;

		// Validar si es un archivo CSV
		if (file.type !== 'text/csv') {
			setAlertMessage("Solo se permiten archivos CSV.");
			setAlertSeverity('error');
			return;
		}

		Papa.parse(file, {
			complete: (result: ParseResult<any>) => {
				const parsedData = result.data;
				// Validar encabezados
				const headers = Object.keys(parsedData[0] || {});
				const isValid = expectedHeaders.every(header => headers.includes(header));
				if (!isValid) {
					setAlertMessage("El archivo CSV no tiene la estructura esperada.");
					setAlertSeverity('error');
					return;
				}
				setJsonData(parsedData);
				setAlertMessage("Archivo cargado correctamente.");
				setAlertSeverity('success');
			},
			header: true, // Usa la primera fila como encabezado
			skipEmptyLines: true, // Ignora l�neas vac�as
		});
	};

	return (
		<Container style={{ padding: '20px' , textAlign: 'center'}}>
			<Grid container direction="row" justifyContent="space-between" spacing={2} sx={{ borderBottom: `2px solid ${themePalette.NAVCOLOR}` }}>
				<h1>Investigador Admin</h1>
			</Grid>
			<Grid container direction="column" spacing={2} mt={2}>
				{alertMessage && (
					<Grid item>
						<Alert severity={alertSeverity}>{alertMessage}</Alert>
					</Grid>
				)}
				<Grid item>
					<Input
						type="file"
						inputProps={{ accept: '.csv' }}
						onChange={handleFileUpload}
					/>
				</Grid>
				<Grid item>
				</Grid>
				<Grid item>
					<pre>{JSON.stringify(jsonData, null, 2)}</pre>
				</Grid>
			</Grid>
		</Container>
	)
}
